import {manageTeamSlice} from './manageTeamSlice';

export default manageTeamSlice.reducer;
